export class PUCDataReq {
  constructor(
    public categoryId: number,
    public categoryType: string,
    public categoryName: string,
    public contentId: string,
    public title: string,
    public titleNew: string | null,
    public text: string,
    public textNew: string | null,
    public status: number,
    public userId: string | null,
    public userName: string | null,
    public hashtag: string[]
  ) {}
}

export class PostUpsertContentsReq {
  constructor(
    public data: PUCDataReq
  ) {
  }
}
